'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/security-consult.png'
import ServiceDetailsImg1 from '../../assets/images/services/cyber-security.png'
import ServiceDetailsImg2 from '../../assets/images/services/iot-security.png'



const PeakMain = () => {
    // State to hold dynamic content
    const [serviceDetails] = useState({
        title: "Security consulting for every context",
        text1: "We can help you create a robust security environment with services that include threat assessments, policy review and development, and master planning.Security decisions you make today can determine your organization’s security and resilience for years to come. Our comprehensive security consulting services enable you to feel more confident about the actions you take to protect your family office, employees, operations, facilities, and assets.",
        image1: ServiceDetailsImg,
        title2: "Integrated Security Consulting Framework for Stronger Risk Mitigation",
        text2: "Based on time-tested best practices as well as real-world experience, our holistic approach to security consulting reflects the interrelated nature of today’s businesses. It’s a classic case where the whole is greater than the sum of its parts – an integrated security framework provides for stronger, more cohesive protection to mitigate threats to your organization.",
        text3: "For example, there are physical, operational, and cyber components to protecting intellectual property. By looking at your security challenges from several vantage points, a Kroll security specialist can help you better prevent, plan for, and respond to threats.",
        title3: "Cyber Security",
        points1: [
            "Advanced Persistent Threat (APT) Defense",
            "Cyber Security Incident and Event Management (SIEM)",
            "Threat Hunting",
            "Cloud EDR, XDR",
            "Breach and Attack Simulators",
            "Deception Technology",
            "Vulnerability and Threat Mgmt",
            "Cyber Security Ratings (SSC)",
            "Dark Web Monitoring",
        ], 
        title4: "OT, IoT Security",
        points2: [
            "IT-OT Segmentation",
            "Secure Manufacturing Operations",
            "Deep OT Analytics",
            "ICS Security",
            "Perdue Model",
            "Converged IT, OT, iOT Security",
        ],
        images: [ ServiceDetailsImg1, ServiceDetailsImg2
        ],
        features: [
            {
                icon: "icon-crane-1",
                title: "Reliable Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
            {
                icon: "icon-buildings",
                title: "Building Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
        ],
    });

    return (
        <React.Fragment>
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">
                                    <h2 className="service-details__title-one">{serviceDetails.title}</h2>
                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    <br></br>
                                    <p className="service-details__text-2">{serviceDetails.text3}</p>
                                   
                                </div>
                                <div class="row">
                                <div className="col-xl-6 col-lg-6">                    
                                     <h4 className="service-details__title-two">{serviceDetails.title3}</h4>

<ul className="list-unstyled service-details__points">
    {serviceDetails.points1.map((point, index) => (
        <li key={index}>
            <div className="icon">
                <i className="far fa-check" />
            </div>
            <div className="text">
                <p>{point}</p>
            </div>
        </li>
    ))}
</ul>  
<br></br>
</div> 
<div className="col-xl-6 col-lg-6">                    
     <h4 className="service-details__title-two">{serviceDetails.title4}</h4>

<ul className="list-unstyled service-details__points">
    {serviceDetails.points2.map((point, index) => (
        <li key={index}>
            <div className="icon">
                <i className="far fa-check" />
            </div>
            <div className="text">
                <p>{point}</p>
            </div>
        </li>
    ))}
</ul>  </div>
</div>     
  <div className="service-details__images-box">
                                    <div className="row">
                                        {serviceDetails.images.map((image, index) => (
                                            <div key={index} className="col-xl-6 col-lg-6">
                                                <div className="service-details__images-single">
                                                    <img src={image} alt="" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
</div>     
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details__sidebar">
                                <div className="service-details__service-list-box">
                                <h4 className="service-details__sidebar-title">Main Service</h4>
                                <ul className="service-details__service-list list-unstyled">
                                    <li className="active">
                                    <Link to="/security-consulting">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Security Consulting
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/audit-&-compliance">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Audit & Compliance
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/cloud-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Cloud Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/network-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Network Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/design-&-implementation">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Design & Implementation
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/managed-it-services">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Managed IT Services
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/ot-iot-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        OT, IoT Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/api-security">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        API Security
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/offensive-security-red-teaming">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Offensive Security, Red Teaming
                                    </Link>
                                    </li>
                                    <li>
                                    <Link to="/vulnerability-assessment">
                                        {" "}
                                        <span className="icon-dubble-arrow-right" />
                                        Vulnerability Assessment
                                    </Link>
                                    </li>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default PeakMain;
